import { makeStyles } from "@material-ui/core";

export const useChangeGenderStyles = makeStyles(() => ({
    textFieldWrapper: {
        paddingTop: "24px"
    },
    buttonWrapper: {
        padding: "12px 16px",
        float: "right"
    }
}));
